// v1.4.0 · Fondo animado muy sutil: malla hexagonal (motivo del logo) que se desplaza lento, unos pocos nodos que
//           se encienden y un resplandor que deriva. Solo transform y opacity; se detiene con «reducir movimiento».
import React from 'react';

const NODES = [
  { l: '8%', t: '22%', d: 0 }, { l: '27%', t: '74%', d: 2.4 }, { l: '46%', t: '12%', d: 4.1 },
  { l: '63%', t: '58%', d: 1.2 }, { l: '82%', t: '28%', d: 3.3 }, { l: '91%', t: '80%', d: 5.2 },
];

export default function BackgroundMesh({ dark = false }) {
  return (
    <div className={`bg-mesh ${dark ? 'dark' : ''}`} aria-hidden>
      <div className="bg-glow" style={{ left: '55%', top: '-12%' }} />
      {!dark && <div className="bg-glow" style={{ left: '-10%', top: '55%', animationDelay: '-9s' }} />}
      {NODES.map((n, i) => (
        <span key={i} className="bg-node" style={{ left: n.l, top: n.t, animationDelay: `${n.d}s` }} />
      ))}
    </div>
  );
}
